import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ReportExportFileType } from '@shared/api';
import { Modal, Radio } from '@shared/widgets';

interface ExportModalProps {
  isOpen: boolean;
  onClose: () => void;
  onExport: (fileType: ReportExportFileType) => void;
}

export const ExportModal = (props: ExportModalProps) => {
  const { t } = useTranslation('reports');

  const exportOptions = useMemo(() => Object.entries(ReportExportFileType).map(([value, label]) => ({ text: t(label), value })), [t]);
  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose} title={t('modals.download.title')}>
      <div className='flex flex-col'>
        <Radio orientation='vertical' options={exportOptions} onChange={(value) => props.onExport(value as ReportExportFileType)} />
      </div>
    </Modal>
  );
};
